import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { Card, CardContent, CardHeader, CardTitle } from '@klear/ui/components/card'
import { Combobox } from '@klear/ui/components/combobox'
import { Building2 } from 'lucide-react'
import { useTraders } from '@klear/ui/hooks/use-traders'
import { useAuth } from '@klear/ui/contexts/auth-context'
import { buildNavPathTrader } from '@klear/constants'
import { useDocumentTitle } from '@klear/ui/hooks/use-document-title'

export default function SelectTrader() {
  useDocumentTitle('Select Trader')
  const navigate = useNavigate()
  const { user } = useAuth()
  const { traders, isLoading } = useTraders()

  useEffect(() => {
    const [singleTraderId] = user.traderIds
    if (!isLoading && singleTraderId && user.traderIds.length === 1 && !user.hasKlearRole) {
      navigate(buildNavPathTrader(singleTraderId.toString()), { replace: true })
    }
  }, [isLoading, user, navigate])

  if (isLoading || traders === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold">Loading traders...</h2>
        </div>
      </div>
    )
  }

  const traderOptions = traders.map((trader) => ({
    value: trader.id.toString(),
    label: trader.name
  }))

  const handleTraderSelect = (traderId: string) => {
    if (traderId) {
      navigate(buildNavPathTrader(traderId))
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="flex items-center justify-center gap-2">
            <Building2 className="h-6 w-6" />
            Select Trader
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-medium">Choose a trader to manage:</label>
            <Combobox placeholder="Select a trader..." options={traderOptions} onChange={handleTraderSelect} />
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
